(()=>{
 let observer;
 const mount=()=>{
 observer?.disconnect();
 const root=document.querySelector('.fm-page:is([data-brand="American Outdoor Grill"],[data-brand="Primo Ceramic Grills"]),.fm-page[data-brand="American Made Grills"],.fm-page[data-brand="TrueFlame"],.fm-page[data-brand="Broil King"]');
 const template=document.getElementById('aog-accordion-chevron');if(!root||!template)return;
 const numberOptions=()=>{
   let number=0;
   root.querySelectorAll('.fm-buy form fieldset.fm-option-group').forEach(fieldset=>{
     if(fieldset.hidden)return;
     const legend=fieldset.querySelector(':scope > legend');if(!legend)return;
     let label=legend.textContent.trim().replace(/^\d+\.\s*/, '');
     const values=[...fieldset.querySelectorAll('[data-fm-choice]')].map(input=>input.value.trim());
     if(values.length&&values.every(value=>/^(propane|natural gas|electric|charcoal)$/i.test(value)))label='Fuel type';
     const text=String(++number)+'. '+label;if(legend.textContent!==text)legend.textContent=text;
   });
 };
 const enhance=()=>{numberOptions();root.querySelectorAll('details:not(.hop-detail)>summary:not([data-aog-chevron])').forEach(summary=>{summary.dataset.aogChevron='true';if(!summary.querySelector(':scope > .ho-icon'))summary.append(template.content.cloneNode(true));});};
 const family=root.querySelector('[data-aog-family]');
 const syncFamily=()=>{
   const selected=[...root.querySelectorAll('[data-fm-choice]:checked')].map(x=>x.value);const fuel=selected.find(x=>/gas|propane/i.test(x));const size=parseInt(selected.find(x=>/inch/i.test(x)));
   root.querySelectorAll('[data-aog-accessory-fuel]').forEach(card=>card.hidden=!!card.dataset.aogAccessoryFuel&&card.dataset.aogAccessoryFuel!==fuel);
   for(const link of family?.querySelectorAll('a')||[]){
     const fuelKey=value=>/natural/i.test(value||'')?'natural gas':String(value||'').toLowerCase();
     const variant=JSON.parse(link.dataset.aogVariants||'[]').find(v=>(root.dataset.brand==='Broil King'?fuelKey(v.fuel)===fuelKey(fuel):v.fuel===fuel)&&(!size||!v.size||v.size===size));
     if(variant){const url=link.dataset.bkFamilyUrl?new URL(link.dataset.bkFamilyUrl,location.origin):new URL(link.href);url.searchParams.set('variant',variant.id);link.href=url.href;}
   }
 };
 root.addEventListener('change',syncFamily);syncFamily();
 enhance();observer=new MutationObserver(enhance);observer.observe(root,{childList:true,subtree:true});
 };
 mount();document.addEventListener('hx27:model-ready',mount);
})();
